import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import {
  ParticipantAuthenticationRequest,
  ParticipantAuthenticationResponse,
  ParticipantElectionContext,
} from './participant-auth.models';

@Injectable({
  providedIn: 'root',
})
export class ParticipantAuthService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  getElectionContext(companySuffix: string, electionGuid: string): Observable<ParticipantElectionContext> {
    return this.http
      .get<ParticipantElectionContext>(`${this.baseUrl}/cipa/authentication/election/${companySuffix}/${electionGuid}`);
  }

  identifyParticipant(
    companySuffix: string,
    electionGuid: string,
    request: ParticipantAuthenticationRequest,
  ): Observable<ParticipantAuthenticationResponse> {
    return this.http
      .post<ParticipantAuthenticationResponse>(`${this.baseUrl}/cipa/authentication/login`, request)
      .pipe(catchError(this.handleError));
  }

  authenticateWithPassword(
    companySuffix: string,
    electionGuid: string,
    request: ParticipantAuthenticationRequest,
  ): Observable<ParticipantAuthenticationResponse> {
    return this.http
      .post<ParticipantAuthenticationResponse>(`${this.baseUrl}/cipa/authentication/login`, request)
      .pipe(catchError(this.handleError));
  }

  buildVotingRedirectUrl(code: string, storageType: 1 | 2): string {
    const target = new URL('/', environment.smocipaClientBaseUrl);
    target.searchParams.set('code', code);
    target.searchParams.set('s', String(storageType));
    return target.toString();
  }

  private readonly handleError = (error: HttpErrorResponse): Observable<never> => {
    const body = error.error as { message?: string; title?: string } | null;
    const message = body?.message
      || body?.title
      || 'Ocorreu um erro ao processar a solicitação. Tente novamente.';
    return throwError(() => new Error(message));
  };
}
